import {
  SITE_URL,
  BASE_TITLE,
  DEFAULT_DESCRIPTION,
} from "@/constants/routeMeta";

function setMetaTag(name, content, attr = "name") {
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function removeCanonical() {
  document.querySelector('link[rel="canonical"]')?.remove();
}

function removeMetaTag(name, attr = "name") {
  document.querySelector(`meta[${attr}="${name}"]`)?.remove();
}

/**
 * title / description / canonical / og:* をまとめて更新する。
 * router.afterEach（ルート共通メタ）と BlogDetailView（記事別メタ）の両方から使う。
 * 静的生成側（scripts/generate-seo-pages.js）と出力形式を揃えること。
 *
 * type: og:type。通常ページは "website"、ブログ記事は "article" を渡す。
 * noindex: 404 等のインデックスさせないページで true。robots meta を付け、
 *          未知パスの canonical を吐かないよう canonical は出さない。
 *          SPA 内遷移で残留しないよう、false のルートでは必ず除去する。
 */
export function updateMeta({
  title,
  description,
  path,
  type = "website",
  noindex = false,
}) {
  const pageTitle = title ? `${title} | ${BASE_TITLE}` : BASE_TITLE;
  const desc = description || DEFAULT_DESCRIPTION;
  const url = SITE_URL + path;

  document.title = pageTitle;
  setMetaTag("description", desc);
  setMetaTag("og:title", pageTitle, "property");
  setMetaTag("og:description", desc, "property");
  setMetaTag("og:url", url, "property");
  setMetaTag("og:type", type, "property");
  if (noindex) {
    setMetaTag("robots", "noindex");
    removeCanonical();
  } else {
    removeMetaTag("robots");
    setCanonical(url);
  }
}
